import {FormInputProps, type SelectOption} from "_types/form";
import {Form} from 'react-bootstrap';
import {Controller, get} from "react-hook-form";
import {Select} from "_ui/Select";
import classnames from "classnames";
import {FilterOptionOption} from "react-select/dist/declarations/src/filters";

export type SelectInputProps = FormInputProps & {
    filterOption?: ((option: FilterOptionOption<unknown>, inputValue: string) => boolean) | null;
    clearable?: boolean;
};

export const SelectInput = ({
    label,
    name,
    placeholder,
    register,
    errors,
    comp,
    multiple,
    className,
    containerClass,
    children,
    refCallback,
    clearable,
    options,
    control,
    filterOption,
    disabled,
    ...otherProps
}: SelectInputProps) => {
    const fieldErrors = get(errors, name);
    className = classnames(className ?? '', {'is-invalid': fieldErrors});

    return (<Form.Group className={containerClass} controlId={name}>
        <Controller
            {...{name, control}}
            render={({field: {ref, ...field}}) => {
                const saveChange = field.onChange;
                const fieldValue = field.value;
                field.onChange = (e: SelectOption) => {
                    saveChange(
                        Array.isArray(e)
                            ? e.length > 0
                                ? e.map(({value}) => value)
                                : null
                            : e?.value
                    );
                };
                const foundValue = multiple
                    ? options?.filter(({value}: any) => fieldValue?.includes(value))
                    : options?.find(({value}: any) => fieldValue === value);

                field.value = ((Array.isArray(foundValue) && foundValue.length == 0) || !foundValue) ? null : foundValue;
                return <Select
                    {...{...field, placeholder, filterOption, className, options, isMulti: multiple, isDisabled: disabled}}
                />
            }}
        />


        {fieldErrors ?
            <Form.Control.Feedback type="invalid">{fieldErrors['message'] as any}</Form.Control.Feedback> : null}
    </Form.Group>);
};
